import React from 'react'
import "./Map.css"

function Map() {
  return (
    <div  className="map">

    

    <div className="mb-5" data-aos="fade-up" data-aos-delay="200">
      <iframe
        style={{ border: 0, width: '100%', height: '370px' }}
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d8953.784368060751!2d-3.073658705496796!3d55.87227615861989!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4887be9e59d59a8b%3A0xcf9e786d1dfea66!2s17%20Morris%20Rd%2C%20Newtongrange%2C%20Dalkeith%20EH22%204ST%2C%20UK!5e0!3m2!1sen!2sin!4v1738837053882!5m2!1sen!2sin" 
        frameBorder="0"
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
    

  
  </div>
  )
}

export default Map